import { Link } from "wouter";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
import { Instagram, MessageCircle, Phone, Mail } from "lucide-react";
import { 
  APP_LOGO, 
  CONTACT_EMAIL, 
  CONTACT_PHONE,
  CONTACT_ADDRESS,
  SOCIAL_INSTAGRAM,
  CONTACT_WHATSAPP
} from "@shared/const";

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo e Tagline */}
          <div className="space-y-6">
            <Link href="/" onClick={scrollToTop}>
              <img 
                src="/images/logos/Fercci_AssinaturaVisual_AuroraeBranco.png" 
                alt="Fercci" 
                className="h-8 w-auto cursor-pointer"
              />
            </Link>
            <p className="text-sm text-primary-foreground/80" style={{marginTop: '20px'}}>
              A tradição da agricultura aliada à tecnologia moderna. Seu parceiro no campo.
            </p>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-base font-semibold mb-4" style={{color: 'var(--aurora)'}}>
              Links Rápidos
            </h3>
            <nav className="flex flex-col space-y-2">
              <Link href="/" onClick={scrollToTop}>
                <span className="text-sm hover:text-[#C7893E] transition-colors cursor-pointer">
                  Home
                </span>
              </Link>
              <Link href="/contato" onClick={scrollToTop}>
                <span className="text-sm hover:text-[#C7893E] transition-colors cursor-pointer">
                  Contato
                </span>
              </Link>
              <Link href="/servicos" onClick={scrollToTop}>
                <span className="text-sm hover:text-[#C7893E] transition-colors cursor-pointer">
                  Serviços
                </span>
              </Link>
              <Link href="/tecnologias" onClick={scrollToTop}>
                <span className="text-sm hover:text-[#C7893E] transition-colors cursor-pointer">
                  Tecnologias
                </span>
              </Link>
              <Link href="/sobre-nos" onClick={scrollToTop}>
                <span className="text-sm hover:text-[#C7893E] transition-colors cursor-pointer">
                  Sobre Nós
                </span>
              </Link>
            </nav>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-base font-semibold mb-4" style={{color: 'var(--aurora)'}}>
              Contato
            </h3>
            <div className="space-y-3 text-sm text-primary-foreground/80">
              {/* WhatsApp com ícone Phone Aurora */}
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4" style={{color: '#D3D655'}} />
                <a href={CONTACT_WHATSAPP} target="_blank" rel="noopener noreferrer" className="hover:text-[#C7893E] transition-colors">
                  {CONTACT_PHONE}
                </a>
              </div>
              
              {/* Email com ícone Mail Aurora */}
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4" style={{color: '#D3D655'}} />
                <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-[#C7893E] transition-colors">
                  {CONTACT_EMAIL}
                </a>
              </div>
              
              {/* Redes Sociais */}
              <div className="flex gap-4 pt-4">
                <a 
                  href={SOCIAL_INSTAGRAM}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#C7893E] transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram className="h-5 w-5" />
                </a>
                <a 
                  href={CONTACT_WHATSAPP}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#C7893E] transition-colors"
                  aria-label="WhatsApp"
                >
                  <MessageCircle className="h-5 w-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright e Aviso de Cookies */}
        <div className="border-t border-primary-foreground/20 pt-6">
          <p className="text-sm text-center text-primary-foreground/60 mb-4">
            © {new Date().getFullYear()} Fercci. Todos os direitos reservados.
          </p>
          <p className="text-xs text-center text-primary-foreground/50 leading-relaxed">
            Este site utiliza cookies para melhorar sua experiência de navegação, personalizar conteúdo e analisar nosso tráfego. 
            Ao continuar navegando, você concorda com nossa política de cookies. 
            Para mais informações, entre em contato conosco.
          </p>
        </div>
      </div>
    </footer>
  );
}

